import { SelectingRectArea } from "containers/Screen/ContextMenu";

export const isWithinRange = (
  range: SelectingRectArea,
  item: SelectingRectArea
) => {
  return !(
    range.left + range.width <= item.left ||
    item.left + item.width <= range.left ||
    range.top + range.height <= item.top ||
    item.top + item.height <= range.top
  );
};
